import React, { useState } from "react";
import "./AdmLoginSignup.css";
import Modal from "../Modal/Modal";
import Tnc from "../tnc/Tnc";
import { useAuth } from "../../Context/AuthContext";

const AdmLoginSignup = () => {
  const [state, setState] = useState("Admin Login");
  const [formData, setFormData] = useState({
    admname: "",
    admemail: "",
    admpassword: "",
    termscond: "",
  });
  const [isChecked, setIsChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSignupAlert, setShowSignupAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const { login, signup } = useAuth();

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(""); // Clear error when user types
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // Check if login button should be enabled
  const isLoginEnabled = () => {
    if (state === "Admin Login") {
      // For login: enable if email is not empty and password has at least 4 characters
      return (
        formData.admemail.trim() !== "" && formData.admpassword.length >= 4
      );
    } else {
      // For signup: enable if all fields are filled and terms are agreed
      return (
        formData.admname.trim() !== "" &&
        formData.admemail.trim() !== "" &&
        formData.admpassword.length >= 4 &&
        isChecked
      );
    }
  };

  const handleLogin = async () => {
    if (!isLoginEnabled()) return;

    setIsLoading(true);
    setError("");

    const result = await login(formData.admemail, formData.admpassword);

    if (!result.success) {
      setError(result.error);
    }
    // If successful, the context will handle navigation
    setIsLoading(false);
  };

  const handleSignup = async () => {
    if (!isLoginEnabled()) return;

    setIsLoading(true);
    setError("");

    const result = await signup(formData);

    if (!result.success) {
      setError(result.error);
    }
    // If successful, the context will handle navigation
    setIsLoading(false);
  };

  const handleSignupClick = () => {
    setShowSignupAlert(true);
  };

  const handleSignupAlertClose = () => {
    setShowSignupAlert(false);
  };

  return (
    <div className="loginsignup">
      <div className="loginsignup-container">
        <h1>{state}</h1>

        {/* Error Display */}
        {error && (
          <div
            style={{
              color: "red",
              backgroundColor: "#ffe6e6",
              padding: "10px",
              borderRadius: "5px",
              marginBottom: "15px",
              fontSize: "14px",
            }}
          >
            {error}
          </div>
        )}

        <div className="loginsignup-fields">
          {state === "Admin Sign Up" ? (
            <input
              type="text"
              placeholder="Your name"
              name="admname"
              value={formData.admname}
              onChange={changeHandler}
            />
          ) : null}
          <input
            type="email"
            placeholder="Email address"
            name="admemail"
            value={formData.admemail}
            onChange={changeHandler}
          />
          <input
            type="password"
            placeholder="Password"
            name="admpassword"
            value={formData.admpassword}
            onChange={changeHandler}
          />
        </div>

        {/* Only show Terms and Conditions for Sign Up, not for Login */}
        {state === "Admin Sign Up" && (
          <div className="loginsignup-agree">
            <input
              type="checkbox"
              name="agree"
              id="agree"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <p>
              I agree to{" "}
              <span
                onClick={() => setIsModalOpen(true)}
                style={{
                  color: "#007bff",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                <strong>Terms and Conditions</strong>
              </span>{" "}
              and understand the <strong>Cancellation Policy</strong>.
            </p>
          </div>
        )}

        <button
          onClick={state === "Admin Sign Up" ? handleSignup : handleLogin}
          disabled={!isLoginEnabled() || isLoading}
          style={{ opacity: isLoading ? 0.7 : 1 }}
        >
          {isLoading ? "Processing..." : state}
        </button>

        <div className="loginsignup-login">
          {state === "Admin Login" ? (
            <p>
              Don't have an account?{" "}
              <span onClick={handleSignupClick}>Sign Up</span>
            </p>
          ) : (
            <p>
              Already have an account?{" "}
              <span onClick={() => setState("Admin Login")}>Login</span>
            </p>
          )}
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Tnc />
      </Modal>

      {/* Signup Alert Modal */}
      <Modal isOpen={showSignupAlert} onClose={handleSignupAlertClose}>
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            backgroundColor: "#fff",
            borderRadius: "8px",
          }}
        >
          <h3 style={{ color: "#dc3545", marginBottom: "15px" }}>
            Access Restricted
          </h3>
          <p style={{ marginBottom: "20px", color: "#666" }}>
            Only existing administrators are allowed to create new admin
            accounts.
          </p>
          <button
            onClick={handleSignupAlertClose}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            OK
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default AdmLoginSignup;
